import type { Action } from 'state/actions';

import type { RouteChanged } from './router.action';
import type { RouterState } from './router.model';
import { initialRouterState } from './router.model';

export function routerReducer(state: RouterState = initialRouterState, action: Action): RouterState {
  switch (action.type) {
    case 'ROUTE_CHANGED':
      return onRouteChangeSuccess(state, action);
    default:
      return state;
  }
}

function onRouteChangeSuccess(_state: RouterState, { path, params }: RouteChanged): RouterState {
  return {
    path,
    params,
  };
}
